<subscription-modal>
    <!-- Subscription Error Modal -->
    <dialog id="subscription-error-modal" class="modal" if="{state.error}" aria-labelledby="subscription-error-modal-title">
        <div class="modal-box max-w-lg">
            <h3 id="subscription-error-modal-title" class="font-bold text-lg mb-4 flex items-center gap-2">
                <i class="icon-metalark-credit-card text-warning text-2xl"></i>
                {locale?.t('subscription_required')}
            </h3>

            <div class="space-y-4">
                <!-- Main message -->
                <div class="alert alert-warning">
                    <i class="icon-metalark-info"></i>
                    <div>
                        <p class="font-semibold">{state.error.message}</p>
                        <p if="{state.error.details.description}" class="text-sm mt-1">
                            {state.error.details.description}
                        </p>
                    </div>
                </div>

                <!-- Grace period warning -->
                <div if="{state.error.details.gracePeriodEnd && state.error.details.daysRemaining}"
                     class="bg-warning/10 border border-warning rounded-lg p-4">
                    <div class="flex items-start gap-3">
                        <i class="icon-metalark-clock text-warning text-xl flex-shrink-0"></i>
                        <div class="text-sm">
                            <p class="font-semibold text-warning mb-1">{locale?.t('subscription_graceactive')}</p>
                            <p class="text-gray-700">
                                {locale?.t('subscription_daysremaining', { count: state.error.details.daysRemaining })}
                            </p>
                            <p class="text-xs text-gray-600 mt-1">
                                {locale?.t('subscription_until', { date: tools?.formatDate(state.error.details.gracePeriodEnd) })}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Blocked operation info -->
                <div if="{state.error.details.blockedOperation}" class="text-sm text-gray-600">
                    <p>
                        <strong>{locale?.t('subscription_blockedop')}:</strong> {state.error.details.blockedOperation}
                    </p>
                    <p if="{state.error.details.requirementLevel === 'REQUIRE_ACTIVE_OR_GRACE'}" class="mt-1">
                        {locale?.t('subscription_grace_viewonly')}
                    </p>
                </div>

                <!-- What you need -->
                <div class="bg-base-200 rounded-lg p-4">
                    <p class="font-semibold text-sm mb-2">{locale?.t('subscription_tocontinue')}:</p>
                    <ul class="text-sm space-y-1 ms-5 list-disc">
                        <li>{locale?.t('subscription_modal_renew')}</li>
                        <li>{locale?.t('subscription_modal_updatepayment')}</li>
                        <li>{locale?.t('subscription_modal_chooseplan')}</li>
                    </ul>
                </div>
            </div>

            <div class="modal-action">
                <button class="btn btn-ghost" onclick="{closeModal}">
                    {locale?.t('cancel')}
                </button>
                <button class="btn btn-primary gap-2" onclick="{goToBilling}">
                    <i class="icon-metalark-credit-card"></i>
                    {locale?.t('subscription_gotobilling')}
                </button>
            </div>
        </div>
        <form method="dialog" class="modal-backdrop">
            <button onclick="{closeModal}">close</button>
        </form>
    </dialog>

    <script>
        import { store } from '../services/store.js';
        import { navigateTo } from '../router/routes';

        export default {
            state: {
                error: null
            },

            onMounted() {
                // Subscribe to Redux store for subscription errors
                this.unsubscribe = store.subscribe(() => {
                    const storeState = store.getState();
                    const newError = storeState.subscriptionError;

                    if (newError && newError !== this.state.error) {
                        this.state.error = newError;
                        this.update();

                        // Show the modal
                        const modal = document.getElementById('subscription-error-modal');
                        if (modal) {
                            modal.showModal();
                        }
                    }
                });

                // Check if there's already an error in the store
                const storeState = store.getState();
                if (storeState.subscriptionError) {
                    this.state.error = storeState.subscriptionError;
                    this.update();

                    // Show the modal after a short delay to ensure DOM is ready
                    setTimeout(() => {
                        const modal = document.getElementById('subscription-error-modal');
                        if (modal) {
                            modal.showModal();
                        }
                    }, 100);
                }
            },

            onBeforeUnmount() {
                if (this.unsubscribe) {
                    this.unsubscribe();
                }
            },

            closeModal() {
                const modal = document.getElementById('subscription-error-modal');
                if (modal) {
                    modal.close();
                }

                // Clear error from store
                store.dispatch({ type: 'clearSubscriptionError' });

                // Clear local state
                this.state.error = null;
                this.update();
            },

            goToBilling() {
                // Close modal
                const modal = document.getElementById('subscription-error-modal');
                if (modal) {
                    modal.close();
                }

                // Clear error from store
                store.dispatch({ type: 'clearSubscriptionError' });

                // Navigate to billing page
                const billingUrl = this.state.error?.details?.billingUrl || '#billing';

                // If it's a hash URL, use navigateTo
                if (billingUrl.startsWith('#')) {
                    navigateTo(billingUrl.substring(1));
                } else if (billingUrl.startsWith('/#')) {
                    navigateTo(billingUrl.substring(2));
                } else {
                    // Full URL, use window.location
                    window.location.href = billingUrl;
                }

                // Clear local state
                this.state.error = null;
                this.update();
            },

        }
    </script>

    <style>
        .alert {
            display: flex;
            align-items: flex-start;
            gap: 1rem;
            padding: 1rem;
            border-radius: 0.5rem;
        }

        .alert-warning {
            background-color: #fff3cd;
            border: 1px solid #ffc107;
            color: #664d03;
        }

        .modal-box {
            max-height: 90vh;
            overflow-y: auto;
        }
    </style>
</subscription-modal>
